<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5">
<h1 class="tochead">Contents</h1>
</a><h2 class="toc"><a id="page_5"></a><a href="#/xhtml/05_Chapter01"><span class="toc_hang">Chapter 1:</span> 1939</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter02" title="Link target outside of Sample"><span class="toc_hang">Chapter 2:</span> 1940</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample"><span class="toc_hang">Chapter 3:</span> 1941</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample"><span class="toc_hang">Chapter 4:</span> 1942</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample"><span class="toc_hang">Chapter 5:</span> 1943</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample"><span class="toc_hang">Chapter 6:</span> 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample"><span class="toc_hang">Chapter 7:</span> 1945</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Endnotes" title="Link target outside of Sample"><em class="italic">Endnotes</em></span></h2>
<a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c1d0df26